export default __webpack_public_path__ + "static/media/TransportationPlanes_03.5ace3390.png";